<template>
    <div class="base-card">
        <slot />
    </div>
</template>
